import React from 'react'
import * as config from 'config'
import { history } from './../../../helpers/history'
import { isMobile } from './../../../services/breakpoints.service'
import {
	StyledImg,
	LineTitleLeft,
	LineTitleRight,
	StyledContainer,
	LineTitleWrapper,
	StyledImgContainer,
	StyledSecondOption,
	StyledForSubscribers,
	StyledPointsContainer,
	StyledForSubscribersPoints,
} from './styled-components.component'

const baseUrl = `${config.contentUrl}loja/produto/`

const LineTitle = ({ children }) => (
	<LineTitleWrapper>
		<LineTitleLeft />
		{children}
		<LineTitleRight />
	</LineTitleWrapper>
)


const ProductGridItem = ({
	id,
	points,
	imageUrl,
	className,
	description,
	secondPrice,
	secondPoints,
	pointsForSubscribers,
	priceNotMember,
	priceForMember,
}) => (
	<StyledContainer
		className={className}
		onClick={() => history.push(`loja/produto/${id}`)}>
		<StyledImgContainer>
			<StyledImg src={baseUrl + imageUrl} />
		</StyledImgContainer>
		<p>
			<span>{description}</span>
		</p>
		{isMobile() ? null : <hr />}
		<p>
			<span className={'bold'}>Por apenas</span>
			<br />
			<StyledPointsContainer>
				<span className={'blue title'}>
						<span className={'bold'} style={{fontSize: 40
						 }} >
						 {priceNotMember.$toReais()}</span> 
				</span>
				<span>&nbsp; reais</span>
			</StyledPointsContainer>

			{/* {priceForMember == null && priceNotMember == null &&   secondPoints !== null && secondPrice !== null && secondPoints > 0 && secondPrice > 0 ? null : (
				<React.Fragment>
					<LineTitle>
						<span className={'bold'}>OU</span>
					</LineTitle>
					<StyledSecondOption className={'center'}>
						<span className={'blue bold'}>
							{secondPoints.toLocaleString('pt-BR')} pontos +{' '}
							{secondPrice.$toReais()}
						</span>
					</StyledSecondOption>
				</React.Fragment>
			)} */}

			{/* <LineTitle>
				<span className={'light-orange bold'}>Clube Muviflex</span>
			</LineTitle>
			<StyledForSubscribers>
				<span>A partir de</span>
				{isMobile() ? ' ' : <br />}
				<StyledForSubscribersPoints className={'blue bold'}>
					{(priceForMember !== null && priceNotMember !== null) &&
						priceForMember.$toReais() + " reais"
						}

					{(priceForMember == null &&	priceNotMember == null) &&
						pointsForSubscribers.toLocaleString('pt-BR') + " pontos"
						}
				</StyledForSubscribersPoints>
			</StyledForSubscribers> */}
		</p>
	</StyledContainer>
)

export default ProductGridItem
